import {
  Grid,
  Typography,
  Button,
  ThemeProvider,
  useTheme,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { formatDecimal } from "@aclymatepackages/formatters";
import { LoadingButton, DefaultPaper } from "@aclymatepackages/atoms";

import { mergeDarkTheme } from "@aclymatepackages/themes";

import useInputMeasurementSystem from "../../helpers/hooks/inputMeasurementSystem";

const TransactionDetailsFooterRow = ({
  saveEnabled,
  saveTransaction,
  acceptText = "Accept",
  tonsCo2e,
  onRejectTransaction,
  calcLoading,
  alert,
  disabled,
}) => {
  const { palette } = useTheme();

  const { convertCarbonUnits, carbonUnitLabel } = useInputMeasurementSystem();

  const displayCarbonVolume = (tonsCo2e) => {
    if (isNaN(tonsCo2e) || !tonsCo2e) {
      return 0;
    }

    const displayVolume = convertCarbonUnits(Math.abs(tonsCo2e));

    return formatDecimal(displayVolume);
  };

  return (
    <Grid container direction="column" spacing={2}>
      {alert && (
        <Grid item>
          <DefaultPaper style={{ backgroundColor: palette.error.main }}>
            <ThemeProvider theme={mergeDarkTheme}>
              <Grid container spacing={2} wrap="nowrap" alignItems="center">
                <Grid item>
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    size="2x"
                    style={{ color: "white" }}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="subtitle2" color="textPrimary">
                    {alert}
                  </Typography>
                </Grid>
              </Grid>
            </ThemeProvider>
          </DefaultPaper>
        </Grid>
      )}
      <Grid
        item
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Typography variant="h4">{`${displayCarbonVolume(
                tonsCo2e,
              )} ${carbonUnitLabel} CO2`}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            {onRejectTransaction && (
              <Grid item>
                <Button
                  variant="contained"
                  onClick={onRejectTransaction}
                  disabled={disabled}
                >
                  Reject
                </Button>
              </Grid>
            )}
            <Grid item>
              <LoadingButton
                label={acceptText}
                color="secondary"
                onClick={saveTransaction}
                disabled={!saveEnabled || disabled}
                isLoading={calcLoading}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default TransactionDetailsFooterRow;
